import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { usePersistedState } from "../hooks/usePersistedState";
import "../styles/dashboard.css";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, user, logoutUser } = useAuth();
  const [collapsed, setCollapsed] = usePersistedState("sidebar-collapsed", false);

  const toggle = () => setCollapsed((prev) => !prev);

  const handleLogout = () => {
    logoutUser();          // Clear user session
    navigate("/");         // 🔥 Redirect to Login page automatically
  };

  return (
    <div className={`sidebar ${collapsed ? "sidebar-collapsed" : ""}`}>
      <div className="sidebar-header">
        <span className="sidebar-logo">PM</span>
        {!collapsed && <span className="sidebar-title">Project Manager</span>}
        <button className="sidebar-toggle" onClick={toggle}>
          {collapsed ? "»" : "«"}
        </button>
      </div>

      {isAuthenticated && (
        <div className="sidebar-user">
          {!collapsed && (
            <>
              <div className="sidebar-username">{user?.name}</div>
              <div className="sidebar-useremail">{user?.email}</div>
            </>
          )}
        </div>
      )}

      <nav className="sidebar-nav">
        <Link
          to="/dashboard"
          className={
            location.pathname.startsWith("/dashboard")
              ? "sidebar-link active"
              : "sidebar-link"
          }
        >
          Dashboard
        </Link>
        <Link
          to="/settings"
          className={
            location.pathname.startsWith("/settings")
              ? "sidebar-link active"
              : "sidebar-link"
          }
        >
          User Settings
        </Link>
      </nav>

      {isAuthenticated && (
        <div className="sidebar-footer">
          <button onClick={handleLogout} className="btn-logout">
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
